<script lang="ts">
	import LearnHeader from '$lib/components/learn/LearnHeader.svelte';
	import { hatchStyle45 } from '$lib/styles/hatch';

	const learnSections = [
		{
			href: '/docs',
			title: 'Documentation',
			description: 'Technical guides and API references for deploying and configuring Corral AI.',
			icon: 'book'
		},
		{
			href: '/learn/tutorials',
			title: 'Tutorials',
			description: 'Step-by-step guides to help you get started and build with Corral AI.',
			icon: 'play'
		},
		{
			href: '/learn/resources',
			title: 'Resources',
			description: 'Whitepapers, case studies, and best practices for enterprise AI.',
			icon: 'file'
		}
	];
</script>

<svelte:head>
	<title>Learn - Corral AI</title>
</svelte:head>

<div class="min-h-screen flex flex-col">
	<LearnHeader />

	<section
		class="bg-[#f9f9f4] py-24 relative flex-1 px-6 lg:px-12"
		style={hatchStyle45}
	>
		<div class="flex flex-col items-center text-center max-w-4xl mx-auto">
			<h1 class="font-display text-[48px] lg:text-[58px] text-black tracking-[-0.04em] leading-[1.1] mb-5">
				Learn
			</h1>
			<p class="font-body text-[16px] lg:text-[18px] text-[#5c5855] max-w-2xl">
				Everything you need to deploy, configure, and build with Corral AI.
			</p>
		</div>

		<div class="mt-16 max-w-4xl mx-auto">
			<div class="grid gap-6 md:grid-cols-3">
				{#each learnSections as section}
					<a
						href={section.href}
						class="group block p-6 bg-white border border-[#e5e5e5] rounded-lg hover:border-[#ee6018] hover:shadow-sm transition-all"
					>
						<div class="w-10 h-10 rounded-lg bg-[#f5f5f5] flex items-center justify-center mb-4 group-hover:bg-[#fff5f0] transition-colors">
							{#if section.icon === 'book'}
								<svg class="w-5 h-5 text-[#5c5855] group-hover:text-[#ee6018] transition-colors" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
									<path d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							{:else if section.icon === 'play'}
								<svg class="w-5 h-5 text-[#5c5855] group-hover:text-[#ee6018] transition-colors" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
									<path d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							{:else if section.icon === 'file'}
								<svg class="w-5 h-5 text-[#5c5855] group-hover:text-[#ee6018] transition-colors" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
									<path d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							{/if}
						</div>
						<h2 class="font-display font-[350] text-[20px] text-[#020202] mb-2 group-hover:text-[#ee6018] transition-colors">
							{section.title}
						</h2>
						<p class="font-body text-[14px] text-[#5c5855] leading-relaxed">
							{section.description}
						</p>
					</a>
				{/each}
			</div>
		</div>
	</section>
</div>
